import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import { BrowserRouter as Router } from 'react-router-dom'
import * as Sentry from '@sentry/browser'
import VConsole from 'vconsole'
import jsbridge from '@xpeng/js-bridge'
import { getClientEnv, isMock } from './utils/common'
import { getUrlParam } from './utils/url'
import SentryInit from './utils/sentry'
import { devtools } from 'stook-devtools'

if (isMock()) {
  require('./mock/bridge');
}

// 禁用顶部分享按钮
jsbridge.registerHandler('onActionButtonShowing', (options, responseCallback) => {
  responseCallback({ share: false });
});

SentryInit()

if (getClientEnv() !== 'production' || getUrlParam('showConsoleFlag') === 'y') {
  new VConsole()
}

if (getClientEnv() !== 'production') {
  devtools.init()
}

const callHandler_origin = jsbridge.callHandler
jsbridge.callHandler = (method, params) => {
  console.log(`====== bridge callHandler start =====`)
  console.log(`method: ${method}`, 'params: ', params)
  Sentry.addBreadcrumb({
    type: 'bridge-callHandler',
    message: `${method} request`,
    data: params,
  })
  return callHandler_origin
    .call(jsbridge, method, params)
    .then((res) => {
      Sentry.addBreadcrumb({
        type: 'bridge-callHandler',
        message: `${method} response`,
        data: res,
      })
      console.log(`method: ${method}`, 'response: ', res)
      console.log(`====== bridge callHandler end ======`)
      return res
    })
    .catch((err) => {
      Sentry.captureException(err)
      console.log(`method: ${method}`, 'error: ', err)
      console.log(`====== bridge callHandler end ======`)
      throw err
    })
}

// 初始化高德地图配置
// @ts-ignore
window._AMapSecurityConfig = {
  serviceHost: `${window.location.protocol}//${window.location.host}/_AMapService`,
};

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)
